import concat from 'lodash/concat';

import store from '../../store';

import Landing from '../../views/Landing.vue';
import Tracking from '../../views/Tracking.vue';

import auth from './auth';
import admin from './admin';
import superAdmin from './superAdmin';
import customer from './customer';

export default concat(
  [
    {
      path: '/',
      name: 'Landing',
      component: Landing,
      async beforeEnter(to, from, next) {
        if (store.state.auth.signed) next({ name: 'Home' });
        else {
          try {
            await store.dispatch('auth/initAuthentication');
            next({ name: 'Home' });
          } catch (error) {
            next({ name: 'SignIn' });
          }
        }
      },
    },
    {
      path: '/tracking',
      name: 'Tracking',
      component: Tracking,
    },
  ],
  auth,
  admin,
  superAdmin,
  customer,
);
